import { Navigate, useLocation } from "react-router-dom";
import { getUserData } from "../../../system";

const ProtectedRoute = ({ children }) => {
  const user = getUserData();
  const location = useLocation();

  // If not logged in -> go to login
  if (!user || Object.keys(user).length === 0) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If user is a super admin -> only allow platform admin paths
  if (user.is_super_admin) {
    const currentPath = location.pathname;
    if (!currentPath.startsWith("/platform-dashboard") && !currentPath.startsWith("/companies")) {
      return <Navigate to="/platform-dashboard" replace />;
    }
    return children;
  } else {
    // If regular user tries to access platform admin paths -> redirect to /dashboard
    const currentPath = location.pathname;
    if (currentPath.startsWith("/platform-dashboard") || currentPath.startsWith("/companies")) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // If user is an employee -> only allow /attendance (prevent access to other private routes)
  // Adjust '/attendance' if your attendance route path is different (e.g. '/attendance/list')
  if (user.is_employee) {
    const currentPath = location.pathname;

    // Allow if already on attendance route (or nested attendance routes)
    if (!currentPath.startsWith("/employee-attendance")) {
      return <Navigate to="/employee-attendance" replace />;
    }
  }
  else if(!user.is_employee){
    const currentPath = location.pathname;

    // Allow if already on attendance route (or nested attendance routes)
    if (currentPath.startsWith("/employee-attendance")) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  // Otherwise allow access to children (MainLayout + nested routes)
  return children;
};

export default ProtectedRoute;
